export default __webpack_public_path__ + "static/media/SWT0020.34I-21273_-15283_0.687ae091.jpg";